import { useModalContext } from "@Containers/ModalContainer";
import { cn } from "@Core/Helpers";
import React, { ComponentProps } from "react";
import { ArrowLeft, X } from "lucide-react";

const ModalHeader = (
    { className, children, ...props }: ComponentProps<"div">
) => {
    const modal = useModalContext();

    return (
        <div
            className={cn(
                'p-3 border-b flex sm:justify-between items-center',
                className
            )}
            {...props}
        >
            <ArrowLeft onClick={modal.close} className="cursor-pointer sm:hidden mr-3" />

            {children}

            <X onClick={modal.close} className="cursor-pointer hidden sm:block" />
        </div>
    );
};

ModalHeader.displayName = 'ModalHeader';

export default ModalHeader;
